import * as actionTypes from "../actionTypes";
import createReducer from "../lib/createReducer";

const defaultState = {};

function SEARCH_START(state, action) {
	const { searchId, targetName, fieldIds } = action;

	const nextState = { ...state };
	nextState[searchId] = {
		__id: searchId,
		apiObject: null,
		fieldIds,
		related: [],
		relatedLoadingId: null,
		tabIds: [],
		targetName,
	};

	return nextState;
}

function SEARCH_SET_TABS(state, action) {
	const { searchId, tabIds } = action;
	return {
		...state,
		[searchId]: {
			...state[searchId],
			tabIds,
		},
	};
}

function SEARCH_DELETE(state, action) {
	const { searchId } = action;
	const nextState = { ...state };
	delete nextState[searchId];
	return nextState;
}

function SEARCH_SET_API_OBJ(state, action) {
	const { apiObject, searchId } = action;
	return {
		...state,
		[searchId]: {
			...state[searchId],
			apiObject,
		},
	};
}

function SEARCH_RELATED_START_LOAD(state, action) {
	const { searchId, loadId } = action;

	if (!searchId || !state[searchId] || !loadId) {
		return state;
	}

	return {
		...state,
		[searchId]: {
			...state[searchId],
			relatedLoadingId: loadId,
		},
	};
}

function SEARCH_RELATED_END_LOAD(state, action) {
	const { searchId, loadId } = action;

	const search = state[searchId];
	if (!search || loadId !== search.relatedLoadingId) {
		return state;
	}

	return {
		...state,
		[searchId]: {
			...state[searchId],
			related: [],
			relatedLoadingId: null,
		},
	};
}

function SEARCH_RELATED_UPDATE(state, action) {
	const { searchId, related, loadId } = action;
	const search = state[searchId];

	if (
		!searchId ||
		!loadId ||
		!Array.isArray(related) ||
		!search ||
		search.relatedLoadingId !== loadId
	) {
		return state;
	}

	return {
		...state,
		[searchId]: {
			...state[searchId],
			related: related,
			relatedLoadingId: null,
		},
	};
}

const handlers = {};
handlers[actionTypes.SEARCH_START] = SEARCH_START;
handlers[actionTypes.SEARCH_DELETE] = SEARCH_DELETE;
handlers[actionTypes.SEARCH_SET_TABS] = SEARCH_SET_TABS;
handlers[actionTypes.SEARCH_SET_API_OBJ] = SEARCH_SET_API_OBJ;
handlers[actionTypes.SEARCH_RELATED_START_LOAD] = SEARCH_RELATED_START_LOAD;
handlers[actionTypes.SEARCH_RELATED_END_LOAD] = SEARCH_RELATED_END_LOAD;
handlers[actionTypes.SEARCH_RELATED_UPDATE] = SEARCH_RELATED_UPDATE;
export default createReducer(defaultState, handlers);
